import { ApiRequest } from "src/helpers";
import { API_END_POINTS } from "src/constants";

export function adminAmcList() {
  return ApiRequest.fetchAdmin({
    method: "get",
    url: `${API_END_POINTS.ADMIN_AMCS}`,
  }).then((response) => response.data);
}
